export default __webpack_public_path__ + "static/17-07e5820d2497e34c27296c33a3e7b5a5.png";